// import React from "react";
import "./DynaInput.scss";

const DynaInput = (props) => {
  return (
    <div
      className={`label-input-dyna ${
        props.className !== undefined ? props.className : ""
      }`}
    >
      <label htmlFor={props.name}>{props.label}</label>
      {props.typeMode === "input" ? (
        <input
          id={props.id}
          className={`dyna-element ${
            props.classNameInput !== undefined ? props.classNameInput : ""
          }`}
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          value={props.value}
          style={props.style}
          disabled={props.disabled}
          onChange={props.onChange}
          onKeyUp={props.onKeyUp}
        />
      ) : props.typeMode === "select" ? (
        <select
          id={props.id}
          className={`dyna-element ${
            props.classNameInput !== undefined ? props.classNameInput : ""
          }`}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
        >
          <option value="" selected disabled hidden>
            {props.optionPlaceholder === undefined
              ? "انتخاب کنید ..."
              : props.optionPlaceholder}
          </option>
          {props.selectOption?.map((v, index) => (
            <option value={v.value} key={"op" + index}>
              {v.label}
            </option>
          ))}
        </select>
      ) : props.typeMode === "textarea" ? (
        <textarea
          id={props.id}
          className={`dyna-element ${
            props.classNameInput !== undefined ? props.classNameInput : ""
          }`}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          style={props.style}
          disabled={props.disabled}
          onChange={props.onChange}
        />
      ) : props.typeMode === "inputFile" ? (
        <div className={`${props.classNameFileMode}`}>
          <label style={{ width: "90%" }}>
            <input
              className={`dyna-element ${
                props.classNameInput !== undefined ? props.classNameInput : ""
              }`}
              type={"file"}
              name={"uploadPicture"}
              onChange={props.onChange}
            />
            <div className="in-input-file">
              <span>{props.fileUploadName}</span>
              <span className="color-plus">+ پیوست فایل</span>
            </div>
          </label>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default DynaInput;
